/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.input {
  appearance: none;
  display: block;
  padding: calc(var(--spacing, 0.25rem) * 3);
  width: 100%;
  border-radius: var(--radius-sm, 0.25rem);
  border-style: var(--tw-border-style);
  border-width: 1px;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  background-color: var(--color-theme-surface, white);
  border-color: var(--color-gray-300, #d4d4d4);
  --tw-border-style: solid;
  border-style: solid;
  height: calc(var(--spacing, 0.25rem) * 10);
}
.input::-webkit-calendar-picker-indicator {
  background: none;
}
.disabled {
  opacity: 30%;
}
input.input[type="time"] {
  padding-top: 0px;
  padding-bottom: 0px;
}
textarea.input {
  height: calc(var(--spacing, 0.25rem) * 24);
}
select.input {
  padding-right: calc(var(--spacing, 0.25rem) * 8);
}
.input.hasLeftIcon {
  padding-left: calc(var(--spacing, 0.25rem) * 10);
}
.input.hasRightIcon {
  padding-right: calc(var(--spacing, 0.25rem) * 9);
}
.input:focus {
  --tw-outline-style: none;
  outline-style: none;
  @media (forced-colors: active) {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  border-color: var(--color-primary-500);
  color: var(--color-emphasis-high, #000);
}
.input[aria-invalid="true"] {
  border-color: var(--color-red-700, oklch(50.5% 0.213 27.518));
}
.leftIcon, .rightIcon {
  display: block;
  display: grid;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: calc(var(--spacing, 0.25rem) * 2);
  bottom: 0px;
  border-radius: var(--radius-sm, 0.25rem);
  height: calc(var(--spacing, 0.25rem) * 7);
  width: calc(var(--spacing, 0.25rem) * 7);
  margin-block: auto;
}
.leftIcon {
  color: var(--color-emphasis-extra, var(--color-primary-500));
}
.rightIcon {
  color: var(--color-emphasis-medium, #525252);
}
.leftIcon svg, .rightIcon svg {
  pointer-events: none;
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
.rightIcon {
  left: auto;
  right: calc(var(--spacing, 0.25rem) * 2);
}
button.rightIcon {
  cursor: pointer;
}
button.rightIcon:hover {
  background-color: var(--color-gray-100, #f5f5f5);
}
.label {
  display: block;
  position: relative;
  width: 100%;
  background-color: transparent;
}
.label .labelText {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  pointer-events: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label .labelText.focus {
  color: var(--color-emphasis-extra, var(--color-primary-500));
}
.label .labelText.hasError {
  color: var(--color-red-700, oklch(50.5% 0.213 27.518));
}
.label .labelText.bold {
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
  color: var(--color-emphasis-high, #000);
}
.label .labelText.bold.focus {
  color: var(--color-emphasis-extra, var(--color-primary-500));
}
.label .labelText.bold.hasError {
  color: var(--color-red-700, oklch(50.5% 0.213 27.518));
}
.label .labelText {
  color: var(--color-gray-500, #737373);
}
div.descriptionText {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  margin-bottom: var(--spacing, 0.25rem);
  color: var(--color-gray-500, #737373);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
